
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/schneehoehen-schneebericht",
      function () {
        return require("private-next-pages/[region]/schneehoehen-schneebericht.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/schneehoehen-schneebericht"])
      });
    }
  